import icon1 from "../../assets/track_icons/icon1.webp";
import icon2 from "../../assets/track_icons/icon2.webp";
import icon3 from "../../assets/track_icons/icon3.webp";
import icon4 from "../../assets/track_icons/icon4.webp";
import icon5 from "../../assets/track_icons/icon5.webp";
import icon6 from "../../assets/track_icons/icon6.webp";
import icon7 from "../../assets/track_icons/icon7.webp";
import icon8 from "../../assets/track_icons/icon8.webp";
import icon9 from "../../assets/track_icons/icon9.webp";
import icon10 from "../../assets/track_icons/icon10.webp";
import icon11 from "../../assets/track_icons/icon11.webp";
import icon12 from "../../assets/track_icons/icon12.webp";
import icon13 from "../../assets/track_icons/icon13.webp";
import icon14 from "../../assets/track_icons/icon14.webp";
import icon15 from "../../assets/track_icons/icon15.webp";
import icon16 from "../../assets/track_icons/icon16.webp";
import icon17 from "../../assets/track_icons/icon17.webp";
import icon18 from "../../assets/track_icons/icon18.webp";
import icon19 from "../../assets/track_icons/icon19.webp";
import icon20 from "../../assets/track_icons/icon20.webp";
export const tracks = [
  { name: "Future of AI & Security", icon: icon1 },
  { name: "Cybersecurity", icon: icon2 },
  { name: "Zero-Trust Focused", icon: icon3 },
  { name: "Aerospace", icon: icon4 },
  { name: "Threat Detection & Response", icon: icon5 },
  { name: "Data Protection", icon: icon6 },
  { name: "AI Forensics", icon: icon7 },
  { name: "Defense Technology", icon: icon8 },
  { name: "Risk Management", icon: icon9 },
  { name: "Intelligence & Innovation", icon: icon10 },
  { name: "AI Encryption", icon: icon11 },
  { name: "Digital Forensics", icon: icon12 },
  { name: "API Security", icon: icon13 },
  { name: "Future & Innovation", icon: icon14 },
  { name: "AI Monitoring", icon: icon15 },
  { name: "Network Detection", icon: icon16 },
  { name: "Cognitive Defense", icon: icon17 },
  { name: "Zero-Trust Cloud", icon: icon18 },
  { name: "Cyber Resilience", icon: icon19 },
  { name: "AI Radar", icon: icon20 },
];


